// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "micro-base-static/js/" + (chunkId === 699 ? "system" : chunkId) + "." + {"276":"84590755","320":"2b0003bb","699":"014879f5","960":"d6568cbd","969":"a657030e"}[chunkId] + ".chunk.js";
};